<template>
    <div class="">
        
        <div v-if="showoverlay==false" > 
            <div class="mt-4" style="position: relative;">
                <p class="pb-3" style="font-size: 12px; color: rgba(0, 28, 56, 1);">Don’t have an account? <a class="back-to-login" :href="$api_url + '/employee/register'" style="font-size: 12px; color: rgba(0, 28, 56, 1); font-weight: 600;">Register here</a></p>
                <b-form @submit.stop.prevent="onSubmit" ref>

                    <b-form-group id="email-group" label="Email / Phone Number" label-for="email">
                        <b-form-input id="email" name="email" placeholder="" v-model="fdata.email" v-validate="{ required: true, min: 3 }" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email/Phone"></b-form-input>
                        <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="password-group" label="Password" label-for="password" class="position-relative">
                        <b-form-input id="password" name="password" placeholder="" :type="showPassword ? 'text' : 'password'" v-model="fdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input><a class="position-absolute password-icon" @click="showPassword = !showPassword"><b-icon icon="eye-fill" v-if="showPassword"></b-icon><b-icon icon="eye-slash" v-else></b-icon></a>
                        <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                    </b-form-group>

                    <template v-if="show_captcha">
                        <b-form-group class="mb-3">
                            <vue-recaptcha
                                ref="recaptcha"
                                @verify="onVerify"
                                @expired="onExpired" 
                                :sitekey="sitekey" :loadRecaptchaScript="true">
                                </vue-recaptcha>    
                        
                        </b-form-group>

                    </template>
                    <div class="clearfix">
                            <b-form-checkbox id="rememberme" class="float-left mt-3 ml-1 d-none" v-model="rememberme" name="rememberme" value="1" unchecked-value="0">
                                Remember Me
                            </b-form-checkbox>
                            <a class="btn btn-link float-right forget-pass-link mt-3 p-0" :href="$api_url + '/employee/reset'">
                                Forgot Your Password?
                            </a>
                        
                    </div>

                    <b-form-group id="login-submit-group">
                        <b-button type="submit" variant="primary" id="lge" class="login-form-submit-btn" ref="submite">Login<b-icon icon="chevron-right" class="ml-2"></b-icon></b-button>
                    </b-form-group>
                </b-form>
            </div>
     </div>
    <div  class='login_load' v-else >
        <div class="trz_loader">
            Signing In ...
            <br />
            <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo text-center" width="100px"/>
        </div>
    </div>

        <b-modal id="show_terms_employee" size="lg" hide-footer title="End User Terms of Use" scrollable>
            <terms ></terms>
            <div class="">
                    <div class="d-flex justify-content-center">
                    <b-form-checkbox v-model="accept" value="true" unchecked-value="false">
                        I accept the terms and use conditions
                    </b-form-checkbox>  
                </div>
                <div class="d-flex justify-content-center mt-2">
                    <b-form-group id="login-submit-group">
                        <b-button :disabled="!accept" type="button" variant="primary" class="" @click="fakesubmissione">Agree & Proceed</b-button>
                    </b-form-group>
                </div>
            </div>
        </b-modal>
    </div>   
    
</template>
 
<script>
    import VueRecaptcha from 'vue-recaptcha';
    export default{
        
        mounted() {
            //console.log('login form info started..');   
            //console.log(this.data);  
        },
        props: [],
        components: {
            'vue-recaptcha': VueRecaptcha,
        },
        data(){            
            
            return {
                                   
                successmsg:'',
                errormsg:[],
                fdata: {email: null, password:null , agree:0},
                showoverlay:false,


                show_captcha : false,
                captcha_verify : false,
                //sitekey: '6LdOYzsbAAAAAOvXGo3cpT1A_m6dsYEEcLczJMCa',
                sitekey: '6Leg2jMqAAAAAD_UnKTKkLpPof4VETXi8nBo7nU0',  
                
                accept : false,
                showPassword: false,
                rememberme : 1,
            }
        },
        methods:{
            
            onVerify: function (response) {
                //console.log('Verify: ' + response);
                this.captcha_verify = true;

            },
            onExpired: function () {
                //console.log('Expired')
                this.captcha_verify = false;
            },
            resetRecaptcha() {
                this.$refs.recaptcha.reset(); // Direct call reset method
                
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetvalidator()
            {
                 this.$validator.reset();
            },
            validateEmail(email) 
            {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            },
            resetForm()
            {
                this.fdata = {
                    
                    //asd:null,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            fakesubmissione : function()
            {
                this.fdata.agree = 1;                
                document.getElementById('lge').click();
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$bvToast.hide();
                
                if(this.show_captcha == true)
                {
                    if(this.captcha_verify == false) 
                    {
                        this.$bvToast.toast('Please check captcha verification.', {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); 
                        return false;
                    }
                }
                

                let submitUrl = '';

                let auth_with = 'phone number';

                if(this.validateEmail(this.fdata.email))
                {
                    auth_with = 'email address';
                    submitUrl = this.$api_url + '/employee/login?f=1';

                }
                    
                else if(isNaN(this.fdata.email) === false)
                    submitUrl = this.$api_url + '/employee/login';
                else
                {
                    alert('Wrong Email/Phone number');
                    return false;
                }
                    

                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 
                    //this.showoverlay=true;
                    axios.post(submitUrl, formData)
                                .then(function (response) 
                                {
                                    
                                    //console.log(response.data);                                
                                    //window.location.href = this.$api_url;
                                    if(response.data.status == 1)
                                    {
                                        window.location.href = this.$api_url;
                                        
                                    }
                                    else if(response.data.status == 4)
                                    {
                                        currentObj.$bvModal.show('show_terms_employee');

                                        currentObj.showoverlay = false;
                                        
                                        /*currentObj.$bvToast.toast('You have to agree the terms and conditions to access this.', {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        });*/
                                    }
                                    else if(response.data.status == 5)
                                    {
                                        
                                        currentObj.showoverlay=false;
                                        currentObj.$bvToast.toast('Please get logged out from other user session and try again', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); 

                                        setTimeout(function() {
                                            window.location.reload()
                                        }, 2000);
                                    }
                                    else if(response.data.status == 2)
                                    {
                                        currentObj.showoverlay=false;
                                        currentObj.$bvToast.toast('Sorry, your account is not yet verified. Please follow the sign up procedure to verify your account.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); 
                                        currentObj.show_captcha = true;                                       
                                    }
                                    else if(response.data.status == 3)
                                    {
                                        currentObj.showoverlay=false;
                                        currentObj.$bvToast.toast('Sorry, either ' + auth_with + ' or password is incorrect.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); 
                                        currentObj.show_captcha = true;                                       
                                    }
                                    else if(response.data.status == 0)
                                    {
                                        currentObj.showoverlay=false;
                                        currentObj.$bvToast.toast('Sorry, no employee found with the specified ' + auth_with + '.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        });                                         
                                        currentObj.show_captcha = true;
                                    }

                                    //this.show_captcha = true;
                                    this.captcha_verify = false;
                                    this.resetRecaptcha();
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.showoverlay=false;
                                    //alert('error');
                                    //this.errormsg = error;
                                    //currentObj.serverError(error);
                                    /*currentObj.$bvToast.toast('Sorry, no employee found with the specified ' + auth_with + '.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true,
                                            noAutoHide:true,
                                        }); 

                                    this.show_captcha = true;
                                    this.captcha_verify = false;
                                    this.resetRecaptcha();*/
                                });
                });
            },            

        },
        created: function(){
            //
        }
    }
</script>

<style scoped>
ul.login-tabs-nav.nav-pills {border: none !important;}
ul.login-tabs-nav.nav-pills li a, ul.login-tabs-nav.nav-pills li:last-child a {border: 1px solid #464d5c !important;}
ul.login-tabs-nav.nav-pills li a.active {border: 1px solid #3490dc !important;}
ul.login-tabs-nav.nav-pills li, ul.login-tabs-nav.nav-pills li a {color: #dee6ff;}
.login-tabs-nav .nav-item:last-child a {
	border-top-right-radius: 0.25rem !important;
	border-bottom-right-radius: 0.25rem !important;
}
.login-tabs-nav .nav-item:first-child a {
	border-top-left-radius: 0.25rem !important;
	border-bottom-left-radius: 0.25rem !important;
}

</style>
   